import { gql } from "urql";

export const drgEnqueueReviewMutationDoc = gql`
  mutation drgEnqueueReview($input: DrgEnqueueReviewInput!) {
    drgEnqueueReview(input: $input) {
      workflowId
      alreadyRunning
    }
  }
`;
